export default ({ fill }) => (
  /**
   * Ícone utilizado para alinhamento do
   * rótulo a esquerda da feição
   */
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.83952 17.2174H0.172852V0.550781H1.83952V17.2174ZM16.8395 4.71745H3.50618V7.21745H16.8395V4.71745ZM11.8395 10.5508H3.50618V13.0508H11.8395V10.5508Z"
      fill={fill || '#797E82'}
    />
  </svg>
);
